/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
 */

import '@polymer/iron-iconset-svg/iron-iconset-svg.js';
const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `<iron-iconset-svg name="cs-action-20" size="20" style="display: none;">
<svg>
  <defs>
    <g id="circle-i">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0c5.523 0 10 4.48 10 10.007 0 5.526-4.477 10.007-10 10.007S0 15.534 0 10.007C0 4.48 4.477 0 10 0z"></path>
      <path fill="#161616" d="M11 7.032l-2-.095.003 8.103h1.985L11 7.032zm0-1l-.012-1.987H9.003L9 6.032h2z"></path>
    </g>
    <g id="circle-i-dashed" viewBox="0 0 43 43">
      <circle cx="21.8955" cy="21.4644" r="19" fill="transparent" stroke-width="4"></circle>
      <path d="M21.88 15.5094C23.23 15.5094 24.34 14.3994 24.34 13.0494C24.34 11.6994 23.23 10.5894 21.88 10.5894C20.56 10.5894 19.45 11.6994 19.45 13.0494C19.45 14.3994 20.56 15.5094 21.88 15.5094ZM23.8 17.3694H19.99V32.3394H23.8V17.3694Z" fill="inherit" stroke="inherit"></path>
    </g>
  </defs>
</svg>
</iron-iconset-svg>`;

document.head.appendChild($_documentContainer.content);
